import { AUTH_FLOWS } from 'common/constants/constants';
import { CenterLoader } from 'connected-components/Loader/Loader';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import {
  constructConstants,
  handleGrantProcessing,
  handleIdentityVerification,
  handleLinkAccountFlow,
  redirectDevClientToLocal,
  getParsedStateFromQs
} from './OAuthHandler.service';

const OAuthHandler = () => {
  const history = useHistory();
  const {
    sessionStorageAccessor,
    localStorageAccessor,
    providerName,
    authFlow,
    authLevel,
    linkAccountToken,
    search,
    testConnectivity,
    identityUrl,
    grantUrl,
    accountLinkUrl
  } = constructConstants();

  useEffect(() => {
    if (getParsedStateFromQs(history)?.shouldRedriectToLocalhost)
      return redirectDevClientToLocal(history);

    window.history.replaceState({}, document.title, '/');

    if (authFlow === AUTH_FLOWS.LINK_ACCOUNT) {
      handleLinkAccountFlow({
        accountLinkUrl,
        linkAccountToken,
        history,
        sessionStorageAccessor,
        localStorageAccessor,
        providerName,
        authFlow,
        authLevel
      });
      return;
    } else if (search.identity) {
      handleIdentityVerification({
        identityUrl,
        providerName,
        testConnectivity,
        history,
        sessionStorageAccessor,
        localStorageAccessor,
        authFlow
      });
      return;
    } else {
      handleGrantProcessing(grantUrl, history);
      return;
    }
  }, []);

  return <CenterLoader />;
};

export default OAuthHandler;
